module.exports = "<ng-container *ngIf=\"EventController.event.timezone.length > 0\">\n  <div class=\"timezone_label\">Attention horaires de :</div>\n  <div class=\"timezone_container\">\n    {{EventController.event.timezone}}\n  </div>\n</ng-container>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/register-event/view/register-timezone/register-timezone.component.html
// module id = ./src/app/screens/register-event/view/register-timezone/register-timezone.component.html
// module chunks = main